export const handleURLCheck = (string) => {
    if (typeof string !== 'string' || !string.trim()) return false;

    try {
        // URL handles valid paths, query strings, fragments, and encoded
        // characters more reliably than a hand-maintained regular expression.
        const url = new URL(string.includes('://') ? string : `https://${string}`);
        const isIPv4 = /^(?:\d{1,3}\.){3}\d{1,3}$/.test(url.hostname);
        const isDomain = url.hostname.includes('.');

        // Preserve the previous behavior: a plain word such as "test" is a
        // search term, not a URL. Accept hostnames with a dot or IPv4 hosts.
        return ['http:', 'https:'].includes(url.protocol) &&
            Boolean(url.hostname) &&
            (isDomain || isIPv4);
    }
    catch {
        return false;
    }
}
